export const TikTokIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path
      fill={props.color || '#707B8F'}
      d="M14.227 0h-3.37v13.623c0 1.623-1.297 2.957-2.91 2.957-1.614 0-2.91-1.334-2.91-2.957 0-1.594 1.268-2.898 2.823-2.956v-3.42c-3.428.057-6.194 2.869-6.194 6.376C1.667 17.16 4.49 20 7.976 20c3.485 0 6.308-2.87 6.308-6.377V6.638a7.805 7.805 0 0 0 4.466 1.507v-3.42C16.215 4.638 14.227 2.55 14.227 0Z"
    />
  </svg>
);
